const autoTimesheetApprovalReducer = (autoApproval = false, action) => {
    switch (action.type) {
        case "ADD_AUTO_TIMESHEET_APPROVAL":
            return action.payload;
        default:
            return autoApproval;
    }
};

export default autoTimesheetApprovalReducer;